import { useRegistrationPageContext } from 'src/views/pages/RegistrationPage/RegistrationPageContext';
import PageHeading from 'src/views/shared/PageHeading/PageHeading';

export interface RegistrationHeaderProps {
  title: string;
}

const RegistrationHeader = ({ title }: RegistrationHeaderProps) => {
  const context = useRegistrationPageContext();

  if (context.loading) {
    return;
  }

  return (
    <PageHeading
      title={
        context.showUpdatedRegisterAccountCopy
          ? 'Create new employer account'
          : title
      }
    />
  );
};

export default RegistrationHeader;
